import locationSerpsData from './locations.json';
import skillSerpsData from './skills.json';

const normalizeSkill = (value: string): string => value.trim().toLowerCase();
const normalizeLocation = (value: string): string => value.trim().toLowerCase();

const skillToSerpSlug = Object.entries(skillSerpsData).reduce<
  Record<string, string>
>((skillMap, [slug, skillName]) => {
  const normalizedSkillName = normalizeSkill(skillName);

  if (!skillMap[normalizedSkillName]) {
    skillMap[normalizedSkillName] = slug;
  }

  return skillMap;
}, {});

const locationToSerpSlug = Object.entries(locationSerpsData).reduce<
  Record<string, string>
>((locationMap, [slug, locationName]) => {
  const normalizedLocationName = normalizeLocation(locationName);

  if (!locationMap[normalizedLocationName]) {
    locationMap[normalizedLocationName] = slug;
  }

  return locationMap;
}, {});

export const getLocationSerpSlug = (
  location?: string | null
): string | undefined =>
  location ? locationToSerpSlug[normalizeLocation(location)] : undefined;

export const getSkillSerpUrl = (
  skill: string,
  locationSerpSlug?: string
): string | undefined => {
  const normalizedSkill = normalizeSkill(skill);
  const slug = skillToSerpSlug[normalizedSkill];

  if (!slug) {
    return undefined;
  }

  if (!locationSerpSlug) {
    return `/jobs/skill/${encodeURIComponent(slug)}`;
  }

  return `/jobs/skill/${encodeURIComponent(slug)}-jobs-in-${encodeURIComponent(
    locationSerpSlug
  )}`;
};
